import React from "react";
import "./HotelSection.css";

import hotel1 from "../../assets/home/lm.jpeg";
import hotel2 from "../../assets/home/hotel2.jpg";
import hotel3 from "../../assets/home/hotel3.jpg";

type Hotel = {
  name: string;
  image: string;
  location: string;
  description: string;
};

const hotels: Hotel[] = [
  {
    name: "LE MERIDIEN",
    image: hotel1,
    location: "THIMPHU",
    description: "Experience the serene beauty of Paro valley.",
  },
  {
    name: "LEMON TREE RESORT",
    image: hotel2,
    location: "THIMPHU",
    description: "A luxury stay in the heart of Bhutan’s capital.",
  },
  {
    name: "THE CAPITAL HOTEL",
    image: hotel3,
    location: "THIMPHU",
    description: "Enjoy nature and comfort in Punakha.",
  },
];

const HotelSection: React.FC = () => {
  return (
    <section className="hotel-section">
      <div className="hotel-header">
        <p className="hotel-lead">
          Step into a realm where the extraordinary becomes reality. From hidden
          valleys to untouched coastlines, these are places that defy
          imagination and stir the soul. Discover the world’s most remarkable
          wonders, carefully curated to inspire your next unforgettable journey.
        </p>

        <h1 className="hotel-title">
          FIND THE BEST
          <br />
          HOTEL
        </h1>
      </div>

      <div className="hotel-grid">
        {hotels.map((h) => (
          <article className="hotel-card" key={h.name}>
            <img src={h.image} alt={h.name} className="hotel-img" />
            {/* dark gradient to improve text contrast */}
            <div className="hotel-shade" />

            <div className="hotel-name">{h.name}</div>
            <div className="hotel-location">{h.location}</div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default HotelSection;
